<template>
    <g>
        <transition name="fade">
            <grid ref="grid" v-if="this.$store.state.spatialSpan.showGrid" />
        </transition>
        <instructions v-if="this.$store.state.taskContainer.showInstructions" />
        <training v-if="this.$store.state.taskContainer.taskPlaying" />
    </g>
</template>

<script>
import { store } from "@/store.js";
import lang from "@/v/spatialSpan/lang.js";
import instructions from "@/v/spatialSpan/instructions.vue";
import training from "@/v/spatialSpan/training.vue";
import grid from "@/v/spatialSpan/grid.vue";


export default {
    name: "spatialSpan",
    //genväg-alias:
    local: store.state.spatialSpan,
    components: {
        instructions,
        training,
        grid,
    },
    mixins: [lang],
    computed: {
        text() {
            return this.getLocalisedText();
        }
    },
    mounted() {
        var level;
        if (store.state.studies == null
        || store.state.studies.ipark == null
        || store.state.studies.ipark.modules == null
        || store.state.studies.ipark.modules.spatialSpan == null
        || store.state.studies.ipark.modules.spatialSpan.level == null)
            level = 1;
        else
            level = Math.max(1, store.state.studies.ipark.modules.spatialSpan.level);
        store.commit("spatialSpan_initLevel", level);

        store.commit('setTaskMode', 'ready');

        store.commit("spatialSpan_initSession");
        store.commit("taskPhase", 0);
        store.commit("taskPhase", 0);
        store.commit("spatialSpan_setInstructionsViewed", true);
        store.commit("spatialSpan_resetGrid");
        store.commit("spatialSpan_showGrid");
    }
};
</script>
